/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_ExportInputs */

const en_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Export...`)
};

const fr_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lot...`)
};

const de_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelexport...`)
};

const it_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione in batch...`)
};

const ru_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт...`)
};

const es_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación por lotes...`)
};

const zh_cn2_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出...`)
};

const ja_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポート...`)
};

const hi_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात...`)
};

const pt_pt2_batch_export = /** @type {(inputs: Batch_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote...`)
};

/**
* | output |
* | --- |
* | "Batch Export..." |
*
* @param {Batch_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_export = /** @type {((inputs?: Batch_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_export(inputs)
	if (locale === "de") return de_batch_export(inputs)
	if (locale === "it") return it_batch_export(inputs)
	if (locale === "ru") return ru_batch_export(inputs)
	if (locale === "es") return es_batch_export(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_export(inputs)
	if (locale === "ja") return ja_batch_export(inputs)
	if (locale === "hi") return hi_batch_export(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_export(inputs)
	return en_batch_export(inputs)
});